/* eslint-disable react/jsx-no-target-blank */
import { Button, Form, Input, message } from "antd";
import { useForm } from "antd/lib/form/Form";
import axios from "axios";
import React, { useContext, useState } from "react";
import { objectiveContext } from "../../../context/Objective";
function Footer() {
  const [isLoading, setIsLoading] = useState();
  const [form] = useForm();

  const { setSolutionActive, setCompanyActive } = useContext(objectiveContext);

  const onFinish = (values) => {
    setIsLoading(true);
    axios
      .post("https://dark-jade-perch-cuff.cyclic.app/subscribe", {
        email: values.useremail,
      })
      .then(
        (response) => {
          form.resetFields();
          message.success("Your Information Sent Sucessfully!");
          setIsLoading(false);
        },
        (error) => {
          message.error(error?.response?.data.message);
        }
      );
  };

  // icons style
  const iconsStyle =
    "mr-[10px] rounded-full bg-[#E6E6E6] flex items-center justify-center w-[35px] h-[32px] cursor-pointer";

  return (
    <div
      onClick={() => {
        setSolutionActive(false);
        setCompanyActive(false);
      }}
      className="bg-[white] min-[1200px]:h-[430px] h-full py-[40px] px-[50px] max-md:px-[40px] footer_parent flex justify-center items-center flex-col max-[500px]:px-[10px]"
    >
      <div className="w-full flex justify-around max-[1100px]:flex-col">
        <div className="flex flex-col max-[1100px]:items-center">
          <h1 className="text-[20px] font-bold mb-5">LOCATION</h1>
          <div className="flex items-center mb-3.5">
            <div>
              <img src="/assets/location_icon.svg" alt="" />
            </div>
            <p className="mb-0 pl-[10px]">Toronto, ON Canada</p>
          </div>
        </div>
        <div className="flex flex-col max-[1100px]:items-center">
          <div className="flex flex-col max-[1100px]:items-center">
            <h1 className="text-[20px] font-bold mb-5">CONTACT</h1>
            <div className="flex items-center mb-3.5">
              <div>
                <img src="/assets/phone_icon.svg" alt="" />
              </div>
              <p className="mb-0 pl-[10px]">+1-866-MWORLDX / +1-866-696-7539</p>
            </div>
            <div className="flex items-center">
              <div>
                <img src="/assets/mail_icon.svg" alt="" />
              </div>
              <a href="mailto:info@metaworldx.com" className="mb-0 pl-[10px]">
                info@metaworldx.com
              </a>
            </div>
          </div>
          <div className="flex flex-col max-[1100px]:items-center mt-10 max-[1100px]:mt-6">
            <h1 className="text-[20px] font-bold mb-5">FOLLOW US</h1>
            <div className="flex items-center justify-between mt-3 max-[1100px]:ml-[-108px] w-[55%]">
              <a href="https://www.facebook.com/metaworld.x" target="_blank">
                <div className={iconsStyle}>
                  <img src="/assets/Facebook_black.svg" alt="facebook" />
                </div>
              </a>
              <a
                href="https://www.instagram.com/metaworld.x/?igshid=YmMyMTA2M2Y%3D"
                target="_blank"
              >
                <div className={iconsStyle}>
                  <img src="/assets/Instagram_black.svg" alt="instagram" />
                </div>
              </a>
              <a href="https://twitter.com/MetaWorldX" target="_blank">
                <div className={iconsStyle}>
                  <img src="/assets/Twitter_black.svg" alt="twitter" />
                </div>
              </a>
              <a
                href="https://www.linkedin.com/company/metaworldx/"
                target="_blank"
              >
                <div className={iconsStyle}>
                  <img src="/assets/LinkedIn_black.svg" alt="linkedIn" />
                </div>
              </a>
            </div>
          </div>
        </div>
        <div className="flex flex-col max-[1100px]:items-center max-[1100px]:mt-6">
          <h1 className="text-[20px] font-bold w-fit mb-5">
            <div className="translate-x-[150px]  max-[1100px]:translate-x-0">
              GET UPDATES
            </div>
          </h1>
          <div className="flex flex-col justify-end text-right max-[1100px]:text-center">
            <div className="text-[black] font-medium relative mb-[10px]">
              Subscribe to our newsletter to stay updated!
            </div>
            <div className="footer_form ">
              <Form
                form={form}
                name="basic"
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                autoComplete="off"
              >
                <Form.Item
                  name="useremail"
                  rules={[
                    {
                      required: true,
                      message: "Please enter email",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Email or Phone"
                    bordered={false}
                    type="email"
                    disabled={isLoading}
                    className="max-[1100px]:text-center"
                  />
                </Form.Item>
                <div className="w-[100%] h-[3px] border-b-[1px] border-solid border-[black] max-[1100px]:right-[5%] mb-[20px]"></div>
                <div className="text-[black] font-medium">
                  Please Visit Our&nbsp;
                  {/* <a
                    href="/assets/privacy.pdf"
                    without
                    rel="noopener noreferrer"
                    target="_blank"
                    className="text-[black] cursor-pointer"
                  >
                    Privacy Policy
                  </a> */}
                  <a
                    href="/privacy-policy"
                    target="_blank"
                    className="!text-[black] cursor-pointer"
                  >
                    Privacy Policy
                  </a>
                </div>
                <Form.Item>
                  <Button
                    className="mt-4 !bg-[#161616] !text-[#ffffff] !font-bold !text-[17px] !h-[50px] !border-none"
                    type="primary"
                    htmlType="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? "SUBSCRIBING..." : "SUBSCRIBE"}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-[10px]">
        <div className="text-[black] font-medium">
          &#169; 2022 MetaWorldX, All rights reserved
        </div>
      </div>
    </div>
  );
}

export default Footer;
